var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('PDFGenerator',{ref:"PDFGenerator"}),_c('BaseLoadingDialog',{attrs:{"sendingData":_vm.sendingData,"msg":_vm.$t('PDFGenerator.saving')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }